import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { SigninRequest, SigninResponse } from '~/features/auth/types/auth.type';

/**
 * 로그인
 * @endpoint POST /auth/signin
 */
export function postSigninApi(body: SigninRequest) {
  return axiosInstance.post<ApiResponse<SigninResponse>>('/auth/signin', body);
}
